import { createRef, useEffect } from 'react'
import { ParkingLayoutProps } from './SingleParkingMap'

export const ParkingO = (props: ParkingLayoutProps) => {
  const ref = createRef<any>()

  useEffect(() => {
    props.available.forEach(available => {
      const spot = ref.current && ref.current.parentNode.getElementById(`space_${available}`)
      if (!spot) {
        return
      }
      spot.classList.add('spot-available')
    })
  }, [ref, props.available])

  return (
    <svg
      width='100%'
      height='100%'
      viewBox='20 0 350 1261'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'>
      <desc>Created with Sketch.</desc>
      <g id='parkingO' stroke='none' strokeWidth='1' fill='none' ref={ref} fillRule='evenodd'>
        <g id='legend' transform='translate(56.247627, 16.000000)'>
          <path
            d='M38.1325485,84.2242987 L38.8460467,40.268504 C39.2005827,18.4269444 57.0121761,0.909061926 78.8566112,0.91770861 L286.752373,1 L286.752373,1 L286.564481,48.7328675 L216.503627,48.4801941 L218.281555,531.061573 L270.028318,530.617083 L269.752373,1219 L52.536084,1219.38669 L53.6894425,612.383326 L0,611.044462 L0.334038582,97.0633266 L38.1325485,84.2242987 Z'
            id='wall01'
            stroke='#353535'
            strokeWidth='2'
            fill='#FFFFFF'
          />
          <path
            d='M196.004777,5.49090935 C195.960189,5.11480332 195.316541,4.9608114 195.036859,4.91141547 C194.985295,2.95764438 194.863928,0.186699492 194.581119,-1.03922881 C194.121011,-3.03373217 189.948107,-2.99996378 189.948107,-2.99996378 L189.834414,-2.99996378 C189.834414,-2.99996378 185.661512,-3.03373217 185.201401,-1.03922881 C184.918593,0.186699211 184.797226,2.95764438 184.745662,4.91141547 C184.465979,4.96081571 183.822336,5.11480332 183.777744,5.49090935 C183.720658,5.97243427 183.777744,5.85498813 183.777744,5.85498813 L184.730063,5.56928519 C184.711634,6.44652324 184.708427,7.04020577 184.708427,7.04020577 L184.708427,16.7760948 C184.708427,16.7760948 184.872752,18.6691872 185.037076,20.3256363 C185.201401,21.9820897 185.661512,22.6581937 187.896325,22.8948262 C190.131136,23.1314673 191.8862,22.8948262 191.8862,22.8948262 C194.121011,22.6581937 194.581119,21.9820897 194.745445,20.3256363 C194.909768,18.6691872 195.074094,16.7760948 195.074094,16.7760948 L195.074094,7.04020577 C195.074094,7.04020577 195.070888,6.44652324 195.052458,5.56928519 L196.004777,5.85498813 C196.004777,5.85498813 196.061867,5.97243427 196.004777,5.49090935 Z M186.273319,2.65761848 C187.428996,1.72240216 189.835735,1.69447413 189.835735,1.69447413 L189.946788,1.69447413 C189.946788,1.69447413 192.353527,1.72240213 193.509202,2.65761848 C194.664878,3.59283482 194.119145,4.77051399 193.926527,5.74036378 C193.733919,6.71021631 193.573409,7.47224386 193.573409,7.47224386 C193.573409,7.47224386 191.970138,6.95268026 189.946788,6.95268026 L189.835735,6.95268026 C187.812381,6.95268026 186.209118,7.47224386 186.209118,7.47224386 C186.209118,7.47224386 186.048607,6.71021631 185.85599,5.74036378 C185.663381,4.77051399 185.117644,3.59283427 186.273319,2.65761848 Z M184.851376,5.30558021 L185.010763,5.30558021 C185.223283,6.48115908 185.488929,7.78946704 185.542056,9.59713619 C185.549626,9.85472294 185.554775,10.1089569 185.557928,10.3611287 C185.183531,10.1808199 184.962578,9.97180271 184.839064,9.81797413 C184.826984,7.22034927 184.851376,5.30558021 184.851376,5.30558021 Z M185.703536,15.8666478 C185.506542,17.8593688 185.291636,17.0665619 185.291636,17.0665619 C185.237921,15.1742064 185.210087,13.2154964 185.196817,11.4444605 C185.396347,11.5624017 185.723244,11.6454235 185.919039,11.6876579 C185.911147,13.0895252 185.843843,14.44738 185.703536,15.8666478 Z M189.585609,20.4722257 L189.474692,20.4722257 C186.253618,20.4722257 185.557928,19.8636165 185.557928,19.8636165 C185.557928,19.8636165 185.557928,19.4781629 185.653679,18.7883977 C185.749435,18.0986405 185.97413,16.8611197 185.97413,16.8611197 C187.784602,17.1857197 189.457919,17.1829207 189.457919,17.1829207 L189.51695,17.1829207 C189.51695,17.1829207 191.275702,17.1857197 193.086172,16.8611197 C193.086172,16.8611197 193.310866,18.0986405 193.40662,18.7883977 C193.502373,19.4781629 193.502373,19.8636165 193.502373,19.8636165 C193.502373,19.8636165 192.806679,20.4722257 189.585609,20.4722257 Z M194.490884,17.0665619 C194.490884,17.0665619 194.275981,17.8593688 194.078984,15.8666478 C193.938678,14.44738 193.87138,13.0895252 193.863484,11.6876579 C194.059281,11.6454235 194.386177,11.5623983 194.585706,11.4444605 C194.572435,13.2154965 194.544599,15.1742064 194.490884,17.0665619 Z M194.943458,9.81797759 C194.819943,9.97180505 194.598988,10.1808231 194.224595,10.3611287 C194.22775,10.1089601 194.2329,9.85471933 194.24047,9.59713278 C194.293601,7.78946507 194.559245,6.48115815 194.771758,5.30558021 L194.931146,5.30558021 C194.931146,5.30558021 194.955539,7.22035076 194.943458,9.81797759 Z'
            id='Shape'
            fill='#D8D8D8'
            transform='translate(189.891261, 10.000000) rotate(-90.000000) translate(-189.891261, -10.000000) '
          />
          <path
            d='M76.7523725,44 L141.752373,44 C144.513796,44 146.752373,46.2385763 146.752373,49 L146.752373,276 L146.752373,276 L71.7523725,251.791304 L71.7523725,49 C71.7523725,46.2385763 73.9909488,44 76.7523725,44 Z'
            id='wall02'
            stroke='#E6E6E6'
            fill='#F8F8F8'
          />
          <path
            d='M195.752373,37 L214.752373,37 L214.752373,37 L214.554021,2.14082977 L285.334617,2.18811724 L285.119584,46.9224068 L214.786814,47.19835 L215.752373,246 L177.752373,258.791304 L177.752373,55 C177.752373,45.0588745 185.811247,37 195.752373,37 Z'
            id='wall03'
            stroke='#E6E6E6'
            fill='#F8F8F8'
          />
          <polygon
            id='wall04'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            points='177.752373 271 215.752373 258 215.752373 513 177.752373 525.791304'
          />
          <polygon
            id='wall04'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            points='230.752373 649 268.752373 636 268.752373 982 230.752373 994.791304'
          />
          <polygon
            id='wall04'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            points='230.752373 1008 268.752373 995 268.752373 1196 230.752373 1208.7913'
          />
          <polygon
            id='wall04'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            points='230.752373 559 268.752373 546 268.752373 603 230.752373 615.791304'
          />
          <path
            d='M71.7523725,265 L146.752373,290 L146.752373,526.918771 C146.752373,529.680195 144.513796,531.918771 141.752373,531.918771 C141.725515,531.918771 141.698657,531.918555 141.671803,531.918122 L76.6718033,530.870586 C73.9421473,530.826595 71.7523725,528.601245 71.7523725,525.871235 L71.7523725,265 L71.7523725,265 Z'
            id='wall05'
            stroke='#E6E6E6'
            fill='#F8F8F8'
          />
          <path
            d='M130.83644,562.085493 L195.83644,563.178528 C198.564703,563.224406 200.752373,565.449173 200.752373,568.177821 L200.752373,1185.01614 C200.752373,1192.74182 194.494196,1199.00722 186.76852,1199.01613 L139.76852,1199.07034 C132.036538,1199.07925 125.7613,1192.81847 125.752382,1185.08649 C125.752376,1185.08111 125.752373,1185.07573 125.752373,1185.07035 L125.752373,567.084786 C125.752373,564.323363 127.990949,562.084786 130.752373,562.084786 C130.780397,562.084786 130.80842,562.085022 130.83644,562.085493 Z'
            id='wall05'
            stroke='#E6E6E6'
            fill='#F8F8F8'
          />
          <polygon
            id='wall05'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            points='1.7523725 98 39.4423119 85.2069204 39.2741372 250.054368 1.58390299 262.820115'
          />
          <polygon
            id='wall05'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            points='1.7523725 278 39.4423119 265.20692 39.2741372 592.054368 1.58390299 604.820115'
          />
          <polygon
            id='wall05'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            points='54.920842 582.79308 92.6107814 570 92.4426068 716.847448 54.7523725 729.613194'
          />
          <polygon
            id='wall05'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            points='54.920842 742.79308 92.6107814 730 92.4426068 876.847448 54.7523725 889.613194'
          />
          <polygon
            id='wall05'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            points='54.920842 903.79308 92.6107814 891 92.4426068 1199.84745 54.7523725 1212.61319'
          />
          <polygon
            id='Path-2'
            fill='#D8D8D8'
            points='55.0257622 96 56.7703345 96 56.7703345 122.45414 59.3997707 122.45414 55.9980961 138.433451 52.3339823 122.483558 55.0257622 122.45414'
          />
          <polygon
            id='Path-2'
            fill='#D8D8D8'
            points='54.4441524 473 56.1887247 473 56.1887247 499.45414 58.8181609 499.45414 55.4164863 515.433451 51.7523725 499.483558 54.4441524 499.45414'
          />
          <polygon
            id='Path-2-Copy-5'
            fill='#D8D8D8'
            points='109.444152 570 111.188725 570 111.188725 596.45414 113.818161 596.45414 110.416486 612.433451 106.752373 596.483558 109.444152 596.45414'
          />
          <polygon
            id='Path-2-Copy-6'
            fill='#D8D8D8'
            points='107.444152 1136 109.188725 1136 109.188725 1162.45414 111.818161 1162.45414 108.416486 1178.43345 104.752373 1162.48356 107.444152 1162.45414'
          />
          <polygon
            id='Path-2-Copy'
            fill='#D8D8D8'
            transform='translate(162.285267, 492.216725) rotate(-180.000000) translate(-162.285267, -492.216725) '
            points='161.444152 471 163.188725 471 163.188725 497.45414 165.818161 497.45414 162.416486 513.433451 158.752373 497.483558 161.444152 497.45414'
          />
          <polygon
            id='Path-2-Copy-7'
            fill='#D8D8D8'
            transform='translate(216.285267, 608.216725) rotate(-180.000000) translate(-216.285267, -608.216725) '
            points='215.444152 587 217.188725 587 217.188725 613.45414 219.818161 613.45414 216.416486 629.433451 212.752373 613.483558 215.444152 613.45414'
          />
          <polygon
            id='Path-2-Copy-8'
            fill='#D8D8D8'
            transform='translate(216.285267, 1156.216725) rotate(-180.000000) translate(-216.285267, -1156.216725) '
            points='215.444152 1135 217.188725 1135 217.188725 1161.45414 219.818161 1161.45414 216.416486 1177.43345 212.752373 1161.48356 215.444152 1161.45414'
          />
          <polygon
            id='Path-2-Copy-2'
            fill='#D8D8D8'
            transform='translate(162.285267, 118.216725) rotate(-180.000000) translate(-162.285267, -118.216725) '
            points='161.444152 97 163.188725 97 163.188725 123.45414 165.818161 123.45414 162.416486 139.433451 158.752373 123.483558 161.444152 123.45414'
          />
          <polygon
            id='Path-2-Copy-3'
            fill='#D8D8D8'
            transform='translate(111.285267, 23.216725) rotate(-270.000000) translate(-111.285267, -23.216725) '
            points='110.444152 2 112.188725 2 112.188725 28.4541405 114.818161 28.4541405 111.416486 44.433451 107.752373 28.4835579 110.444152 28.4541405'
          />
          <polygon
            id='Path-2-Copy-4'
            fill='#D8D8D8'
            transform='translate(85.285267, 550.216725) rotate(-90.000000) translate(-85.285267, -550.216725) '
            points='84.4441524 529 86.1887247 529 86.1887247 555.45414 88.8181609 555.45414 85.4164863 571.433451 81.7523725 555.483558 84.4441524 555.45414'
          />
          <polygon
            id='Triangle'
            fill='#D8D8D8'
            transform='translate(149.752373, 42.000000) rotate(-225.000000) translate(-149.752373, -42.000000) '
            points='149.752373 40 151.752373 44 147.752373 44'
          />
          <polygon
            id='Triangle-Copy-2'
            fill='#D8D8D8'
            transform='translate(153.752373, 38.000000) rotate(-225.000000) translate(-153.752373, -38.000000) '
            points='153.752373 36 155.752373 40 151.752373 40'
          />
          <polygon
            id='Triangle-Copy-3'
            fill='#D8D8D8'
            transform='translate(157.752373, 34.000000) rotate(-225.000000) translate(-157.752373, -34.000000) '
            points='157.752373 32 159.752373 36 155.752373 36'
          />
          <polygon
            id='Triangle-Copy-4'
            fill='#D8D8D8'
            transform='translate(161.752373, 30.000000) rotate(-225.000000) translate(-161.752373, -30.000000) '
            points='161.752373 28 163.752373 32 159.752373 32'
          />
          <polygon
            id='Triangle-Copy-5'
            fill='#D8D8D8'
            transform='translate(165.752373, 26.000000) rotate(-225.000000) translate(-165.752373, -26.000000) '
            points='165.752373 24 167.752373 28 163.752373 28'
          />
          <polygon
            id='Triangle-Copy-6'
            fill='#D8D8D8'
            transform='translate(169.752373, 22.000000) rotate(-225.000000) translate(-169.752373, -22.000000) '
            points='169.752373 20 171.752373 24 167.752373 24'
          />
          <rect id='Rectangle' fill='#D8D8D8' x='171.752373' y='18' width='43' height='1' />
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_29'
          transform='translate(130.000000, 88.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='29'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              29
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_28'
          transform='translate(131.000000, 63.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='-6.38863962e-14 4.39648318e-14 33 11 33 33 -6.38863962e-14 22'
          />
          <path
            d='M19.8381955,18.9504391 L20.8610988,18.4627316 C20.9847713,18.4044529 21.0352626,18.2620727 20.9738765,18.1446898 L20.7515713,17.7196058 C20.6901852,17.6022229 20.5401608,17.5542994 20.4164883,17.6125636 L19.851196,17.8846805 L18.9525296,16.0693369 C18.8780057,15.9187884 18.6752622,15.7965827 18.5,15.7965827 L16.4336547,15.7965827 L16.362213,15.3220111 L18.2499998,15.3220111 C18.3880765,15.3220111 18.5,15.2157799 18.5,15.0847253 L18.5,14.6101537 C18.5,14.479099 18.3880765,14.3728678 18.2499998,14.3728678 L16.2193603,14.3728678 L16.1463927,13.8880569 C16.6378936,13.8196113 17.0131987,13.4119211 16.9996337,12.9235184 C16.9859313,12.4297137 16.5675506,12.0239642 16.0476836,12.0010524 C15.4737243,11.975751 15,12.4099302 15,12.9491385 C15.0059357,13.0387724 14.9755096,12.8202273 15.5050201,16.3382531 C15.5402221,16.5720485 15.7511749,16.7457115 16,16.7457115 L18.1824796,16.7457115 L19.1633756,18.7271726 C19.2826383,18.9681516 19.5874325,19.0685896 19.8381955,18.9504391 Z M15.6104212,20 C16.6763943,20 17.5950186,19.3621651 18,18.4507259 L17.6180486,17.643519 L17.2545647,17.643519 C17.1390668,18.4418373 16.4458185,19.0574076 15.6104212,19.0574076 C14.6944476,19.0574076 13.9492441,18.3174259 13.9492441,17.4078709 C13.9492441,16.7965867 14.2858451,16.2619054 14.7846414,15.976953 C14.7295865,15.5945426 14.6831353,15.2720798 14.6439118,15 C13.6816174,15.3822378 13,16.3174518 13,17.4078709 C13,18.8371779 14.1710279,20 15.6104212,20 Z'
            id='w'
            fill='#FFFFFF'
            fillRule='nonzero'
          />
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_235'
          transform='translate(237.000000, 64.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(16.500000, 23.000000) scale(-1, 1) translate(-16.500000, -23.000000) '
            points='-1.17239551e-13 -3.83026943e-15 33 11 33 46 -6.38863962e-14 35'
          />
          <path
            d='M19.8381955,25.9504391 L20.8610988,25.4627316 C20.9847713,25.4044529 21.0352626,25.2620727 20.9738765,25.1446898 L20.7515713,24.7196058 C20.6901852,24.6022229 20.5401608,24.5542994 20.4164883,24.6125636 L19.851196,24.8846805 L18.9525296,23.0693369 C18.8780057,22.9187884 18.6752622,22.7965827 18.5,22.7965827 L16.4336547,22.7965827 L16.362213,22.3220111 L18.2499998,22.3220111 C18.3880765,22.3220111 18.5,22.2157799 18.5,22.0847253 L18.5,21.6101537 C18.5,21.479099 18.3880765,21.3728678 18.2499998,21.3728678 L16.2193603,21.3728678 L16.1463927,20.8880569 C16.6378936,20.8196113 17.0131987,20.4119211 16.9996337,19.9235184 C16.9859313,19.4297137 16.5675506,19.0239642 16.0476836,19.0010524 C15.4737243,18.975751 15,19.4099302 15,19.9491385 C15.0059357,20.0387724 14.9755096,19.8202273 15.5050201,23.3382531 C15.5402221,23.5720485 15.7511749,23.7457115 16,23.7457115 L18.1824796,23.7457115 L19.1633756,25.7271726 C19.2826383,25.9681516 19.5874325,26.0685896 19.8381955,25.9504391 Z M15.6104212,27 C16.6763943,27 17.5950186,26.3621651 18,25.4507259 L17.6180486,24.643519 L17.2545647,24.643519 C17.1390668,25.4418373 16.4458185,26.0574076 15.6104212,26.0574076 C14.6944476,26.0574076 13.9492441,25.3174259 13.9492441,24.4078709 C13.9492441,23.7965867 14.2858451,23.2619054 14.7846414,22.976953 C14.7295865,22.5945426 14.6831353,22.2720798 14.6439118,22 C13.6816174,22.3822378 13,23.3174518 13,24.4078709 C13,25.8371779 14.1710279,27 15.6104212,27 Z'
            id='w'
            fill='#FFFFFF'
            fillRule='nonzero'
          />
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_211'
          transform='translate(167.000000, 61.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='12.6165048 0.205501587 33 7 33 29 -1.17239551e-13 18 0 0.28238857'
          />
          <path
            d='M19.8381955,14.9504391 L20.8610988,14.4627316 C20.9847713,14.4044529 21.0352626,14.2620727 20.9738765,14.1446898 L20.7515713,13.7196058 C20.6901852,13.6022229 20.5401608,13.5542994 20.4164883,13.6125636 L19.851196,13.8846805 L18.9525296,12.0693369 C18.8780057,11.9187884 18.6752622,11.7965827 18.5,11.7965827 L16.4336547,11.7965827 L16.362213,11.3220111 L18.2499998,11.3220111 C18.3880765,11.3220111 18.5,11.2157799 18.5,11.0847253 L18.5,10.6101537 C18.5,10.479099 18.3880765,10.3728678 18.2499998,10.3728678 L16.2193603,10.3728678 L16.1463927,9.88805688 C16.6378936,9.81961128 17.0131987,9.41192111 16.9996337,8.92351843 C16.9859313,8.42971367 16.5675506,8.02396419 16.0476836,8.00105244 C15.4737243,7.97575103 15,8.4099302 15,8.94913846 C15.0059357,9.03877237 14.9755096,8.82022726 15.5050201,12.3382531 C15.5402221,12.5720485 15.7511749,12.7457115 16,12.7457115 L18.1824796,12.7457115 L19.1633756,14.7271726 C19.2826383,14.9681516 19.5874325,15.0685896 19.8381955,14.9504391 Z M15.6104212,16 C16.6763943,16 17.5950186,15.3621651 18,14.4507259 L17.6180486,13.643519 L17.2545647,13.643519 C17.1390668,14.4418373 16.4458185,15.0574076 15.6104212,15.0574076 C14.6944476,15.0574076 13.9492441,14.3174259 13.9492441,13.4078709 C13.9492441,12.7965867 14.2858451,12.2619054 14.7846414,11.976953 C14.7295865,11.5945426 14.6831353,11.2720798 14.6439118,11 C13.6816174,11.3822378 13,12.3174518 13,13.4078709 C13,14.8371779 14.1710279,16 15.6104212,16 Z'
            id='w'
            fill='#FFFFFF'
            fillRule='nonzero'
          />
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_1'
          transform='translate(59.000000, 106.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='1' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              1
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_234'
          transform='translate(236.000000, 101.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='234'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              234
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_10'
          transform='translate(59.000000, 285.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='10'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              10
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_4'
          transform='translate(59.000000, 160.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='4' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              4
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_231'
          transform='translate(236.000000, 155.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='231'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              231
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_228'
          transform='translate(236.000000, 209.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='228'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              228
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_13'
          transform='translate(59.000000, 339.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='13'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              13
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_7'
          transform='translate(59.000000, 214.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='7' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              7
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_16'
          transform='translate(59.000000, 393.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='16'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              16
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_2'
          transform='translate(59.000000, 124.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='2' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              2
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_233'
          transform='translate(236.000000, 119.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='233'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              233
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_11'
          transform='translate(59.000000, 303.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='11'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              11
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_5'
          transform='translate(59.000000, 178.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='5' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              5
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_230'
          transform='translate(236.000000, 173.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='230'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              230
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_227'
          transform='translate(236.000000, 227.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='227'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              227
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_14'
          transform='translate(59.000000, 357.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='14'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              14
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_8'
          transform='translate(59.000000, 232.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='8' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              8
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_17'
          transform='translate(59.000000, 411.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='17'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              17
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_3'
          transform='translate(59.000000, 142.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='3' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              3
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_232'
          transform='translate(236.000000, 137.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='232'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              232
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_12'
          transform='translate(59.000000, 321.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='12'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              12
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_6'
          transform='translate(59.000000, 196.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='6' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              6
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_229'
          transform='translate(236.000000, 191.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='229'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              229
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_226'
          transform='translate(236.000000, 245.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='226'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              226
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_225'
          transform='translate(236.000000, 278.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='225'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              225
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_222'
          transform='translate(236.000000, 332.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='222'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              222
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_219'
          transform='translate(236.000000, 386.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='219'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              219
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_224'
          transform='translate(236.000000, 296.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='224'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              224
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_221'
          transform='translate(236.000000, 350.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='221'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              221
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_218'
          transform='translate(236.000000, 404.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='218'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              218
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_223'
          transform='translate(236.000000, 314.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='223'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              223
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_220'
          transform='translate(236.000000, 368.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='220'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              220
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_217'
          transform='translate(236.000000, 422.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='217'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              217
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_214'
          transform='translate(236.000000, 476.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='214'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              214
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_216'
          transform='translate(236.000000, 440.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='216'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              216
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_213'
          transform='translate(236.000000, 494.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='213'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              213
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_215'
          transform='translate(236.000000, 458.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='215'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              215
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_212'
          transform='translate(236.000000, 512.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='212'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              212
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_55'
          transform='translate(112.000000, 626.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='55'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              55
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_184'
          transform='translate(289.000000, 602.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='184'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              184
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_181'
          transform='translate(289.000000, 692.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='181'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              181
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_178'
          transform='translate(289.000000, 746.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='178'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              178
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_175'
          transform='translate(289.000000, 800.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='175'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              175
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_172'
          transform='translate(289.000000, 854.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='172'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              172
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_169'
          transform='translate(289.000000, 908.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='169'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              169
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_166'
          transform='translate(289.000000, 962.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='166'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              166
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_165'
          transform='translate(289.000000, 980.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='165'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              165
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_53'
          transform='translate(112.000000, 590.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='53'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              53
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_186'
          transform='translate(289.000000, 566.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='186'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              186
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_183'
          transform='translate(289.000000, 656.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='183'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              183
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_180'
          transform='translate(289.000000, 710.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='180'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              180
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_177'
          transform='translate(289.000000, 764.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='177'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              177
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_174'
          transform='translate(289.000000, 818.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='174'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              174
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_171'
          transform='translate(289.000000, 872.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='171'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              171
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_168'
          transform='translate(289.000000, 926.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='168'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              168
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_56'
          transform='translate(112.000000, 644.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='56'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              56
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_54'
          transform='translate(112.000000, 608.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='54'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              54
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_185'
          transform='translate(289.000000, 584.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='185'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              185
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_182'
          transform='translate(289.000000, 674.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='182'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              182
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_179'
          transform='translate(289.000000, 728.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='179'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              179
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_176'
          transform='translate(289.000000, 782.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='176'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              176
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_173'
          transform='translate(289.000000, 836.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='173'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              173
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_170'
          transform='translate(289.000000, 890.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='170'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              170
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_167'
          transform='translate(289.000000, 944.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='167'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              167
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_162'
          transform='translate(289.000000, 1051.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='162'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              162
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_161'
          transform='translate(289.000000, 1069.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='161'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              161
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_164'
          transform='translate(289.000000, 1015.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='164'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              164
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_163'
          transform='translate(289.000000, 1033.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='163'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              163
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_158'
          transform='translate(289.000000, 1123.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='158'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              158
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_157'
          transform='translate(289.000000, 1141.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='157'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              157
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_160'
          transform='translate(289.000000, 1087.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='160'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              160
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_159'
          transform='translate(289.000000, 1105.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='159'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              159
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_154'
          transform='translate(289.000000, 1195.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='154'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              154
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_156'
          transform='translate(289.000000, 1159.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='156'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              156
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_155'
          transform='translate(289.000000, 1177.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='155'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              155
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_57'
          transform='translate(112.000000, 662.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='57'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              57
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_58'
          transform='translate(112.000000, 680.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='58'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              58
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_59'
          transform='translate(112.000000, 698.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='59'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              59
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_60'
          transform='translate(112.000000, 716.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='60'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              60
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_63'
          transform='translate(112.000000, 786.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='63'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              63
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_61'
          transform='translate(112.000000, 750.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='61'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              61
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_64'
          transform='translate(112.000000, 804.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='64'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              64
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_62'
          transform='translate(112.000000, 768.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='62'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              62
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_65'
          transform='translate(112.000000, 822.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='65'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              65
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_66'
          transform='translate(112.000000, 840.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='66'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              66
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_67'
          transform='translate(112.000000, 858.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='67'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              67
            </tspan>
          </text>
        </g>
        <g id='spare-68' transform='translate(112.000000, 876.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='68'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              68
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_71'
          transform='translate(112.000000, 947.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='71'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              71
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_69'
          transform='translate(112.000000, 911.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='69'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              69
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_72'
          transform='translate(112.000000, 965.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='72'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              72
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_70'
          transform='translate(112.000000, 929.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='70'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              70
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_73'
          transform='translate(112.000000, 983.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='73'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              73
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_74'
          transform='translate(112.000000, 1001.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='74'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              74
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_75'
          transform='translate(112.000000, 1019.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='75'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              75
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_76'
          transform='translate(112.000000, 1037.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='76'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              76
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_79'
          transform='translate(112.000000, 1091.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='79'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              79
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_77'
          transform='translate(112.000000, 1055.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='77'
            opacity='0.769999981'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              77
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_80'
          transform='translate(112.000000, 1109.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='80'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              80
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_78'
          transform='translate(112.000000, 1073.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='78'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              78
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_81'
          transform='translate(112.000000, 1127.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='81'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              81
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_82'
          transform='translate(112.000000, 1145.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='82'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              82
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_83'
          transform='translate(112.000000, 1163.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='83'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              83
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_84'
          transform='translate(112.000000, 1181.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='84'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              84
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_85'
          transform='translate(112.000000, 1199.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='85'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              85
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_15'
          transform='translate(59.000000, 375.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='15'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              15
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_9'
          transform='translate(59.000000, 250.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='9' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              9
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_18'
          transform='translate(59.000000, 429.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='18'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              18
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_19'
          transform='translate(59.000000, 447.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='19'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              19
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_20'
          transform='translate(59.000000, 465.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='20'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              20
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_24'
          transform='translate(59.000000, 537.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='24'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              24
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_21'
          transform='translate(59.000000, 483.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='21'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              21
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_25'
          transform='translate(59.000000, 555.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='25'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              25
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_22'
          transform='translate(59.000000, 501.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='22'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              22
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_26'
          transform='translate(59.000000, 573.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='26'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              26
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_23'
          transform='translate(59.000000, 519.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='23'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              23
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_27'
          transform='translate(59.000000, 591.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='27'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              27
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_209'
          transform='translate(166.000000, 100.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='209'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              209
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_210'
          transform='translate(166.000000, 82.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='210'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              210
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_208'
          transform='translate(166.000000, 118.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='208'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              208
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_207'
          transform='translate(166.000000, 136.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='207'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              207
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_206'
          transform='translate(166.000000, 154.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='206'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              206
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_204'
          transform='translate(166.000000, 190.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='204'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              204
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_205'
          transform='translate(166.000000, 172.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='205'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              205
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_203'
          transform='translate(166.000000, 208.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='203'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              203
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_202'
          transform='translate(166.000000, 226.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='202'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              202
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_201'
          transform='translate(166.000000, 244.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='201'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              201
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_200'
          transform='translate(166.000000, 262.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='200'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              200
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_30'
          transform='translate(130.000000, 106.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='30'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              30
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_31'
          transform='translate(130.000000, 124.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='31'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              31
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_32'
          transform='translate(130.000000, 142.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='32'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              32
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_86'
          transform='translate(184.000000, 591.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='86'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              86
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_152'
          transform='translate(220.000000, 603.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='152'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              152
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_153'
          transform='translate(220.000000, 585.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='153'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              153
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_151'
          transform='translate(220.000000, 621.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='151'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              151
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_150'
          transform='translate(220.000000, 639.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='150'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              150
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_149'
          transform='translate(220.000000, 657.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='149'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              149
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_148'
          transform='translate(220.000000, 675.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='148'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              148
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_87'
          transform='translate(184.000000, 609.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='87'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              87
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_88'
          transform='translate(184.000000, 627.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='88'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              88
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_89'
          transform='translate(184.000000, 645.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='89'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              89
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_90'
          transform='translate(184.000000, 663.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='90'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              90
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_147'
          transform='translate(220.000000, 693.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='147'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              147
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_147'
          transform='translate(220.000000, 711.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='146'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              146
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_145'
          transform='translate(220.000000, 729.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='145'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              145
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_91'
          transform='translate(184.000000, 681.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='91'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              91
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_92'
          transform='translate(184.000000, 699.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='92'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              92
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_93'
          transform='translate(184.000000, 717.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='93'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              93
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_94'
          transform='translate(184.000000, 735.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='94'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              94
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_144'
          transform='translate(220.000000, 747.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='144'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              144
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_143'
          transform='translate(220.000000, 765.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='143'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              143
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_142'
          transform='translate(220.000000, 783.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='142'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              142
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_141'
          transform='translate(220.000000, 801.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='141'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              141
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_95'
          transform='translate(184.000000, 753.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='95'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              95
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_96'
          transform='translate(184.000000, 771.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='96'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              96
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_97'
          transform='translate(184.000000, 789.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='97'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              97
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_98'
          transform='translate(184.000000, 807.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='98'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              98
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_140'
          transform='translate(220.000000, 819.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='140'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              140
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_139'
          transform='translate(220.000000, 837.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='139'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              139
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_138'
          transform='translate(220.000000, 855.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='138'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              138
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_137'
          transform='translate(220.000000, 873.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='137'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              137
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_99'
          transform='translate(184.000000, 825.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='99'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              99
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_100'
          transform='translate(184.000000, 843.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='100'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              100
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_101'
          transform='translate(184.000000, 861.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='101'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              101
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_136'
          transform='translate(220.000000, 891.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='136'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              136
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_102'
          transform='translate(184.000000, 879.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='102'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              102
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_103'
          transform='translate(184.000000, 897.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='103'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              103
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_135'
          transform='translate(220.000000, 909.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='135'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              135
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_134'
          transform='translate(220.000000, 927.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='134'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              134
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_133'
          transform='translate(220.000000, 945.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='133'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              133
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_132'
          transform='translate(220.000000, 963.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='132'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              132
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_104'
          transform='translate(184.000000, 915.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='104'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              104
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_105'
          transform='translate(184.000000, 933.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='105'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              105
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_106'
          transform='translate(184.000000, 951.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='106'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              106
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_131'
          transform='translate(220.000000, 981.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='131'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              131
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_107'
          transform='translate(184.000000, 969.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='107'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              107
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_108'
          transform='translate(184.000000, 987.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='108'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              108
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_130'
          transform='translate(220.000000, 999.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='130'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              130
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_129'
          transform='translate(220.000000, 1017.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='129'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              129
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_128'
          transform='translate(220.000000, 1035.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='128'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              128
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_127'
          transform='translate(220.000000, 1053.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='127'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              127
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_109'
          transform='translate(184.000000, 1005.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='109'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              109
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_110'
          transform='translate(184.000000, 1023.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='110'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              110
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_111'
          transform='translate(184.000000, 1041.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='111'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              111
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_126'
          transform='translate(220.000000, 1071.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='126'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              126
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_112'
          transform='translate(184.000000, 1059.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='112'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              112
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_113'
          transform='translate(184.000000, 1077.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='113'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              113
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_125'
          transform='translate(220.000000, 1089.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='125'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              125
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_124'
          transform='translate(220.000000, 1107.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='124'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              124
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_123'
          transform='translate(220.000000, 1125.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='123'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              123
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_122'
          transform='translate(220.000000, 1143.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='122'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              122
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_114'
          transform='translate(184.000000, 1095.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='114'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              114
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_115'
          transform='translate(184.000000, 1113.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='115'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              115
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_116'
          transform='translate(184.000000, 1131.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='116'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              116
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_121'
          transform='translate(220.000000, 1161.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='121'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              121
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_120'
          transform='translate(220.000000, 1179.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='120'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              120
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_119'
          transform='translate(184.000000, 1185.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='119'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              119
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_117'
          transform='translate(184.000000, 1149.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='117'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              117
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_118'
          transform='translate(184.000000, 1167.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='118'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              118
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_34'
          transform='translate(130.000000, 178.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='34'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              34
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_33'
          transform='translate(130.000000, 160.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='33'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              33
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_35'
          transform='translate(130.000000, 196.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='35'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              35
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_36'
          transform='translate(130.000000, 214.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='36'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              36
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_37'
          transform='translate(130.000000, 232.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='37'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              37
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_38'
          transform='translate(130.000000, 250.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='38'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              38
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_199'
          transform='translate(166.000000, 297.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='199'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              199
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_198'
          transform='translate(166.000000, 315.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='198'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              198
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_197'
          transform='translate(166.000000, 333.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='197'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              197
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_196'
          transform='translate(166.000000, 351.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='196'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              196
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_195'
          transform='translate(166.000000, 369.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='195'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              195
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_194'
          transform='translate(166.000000, 387.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='194'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              194
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_40'
          transform='translate(130.000000, 303.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='40'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              40
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_39'
          transform='translate(130.000000, 285.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='39'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              39
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_41'
          transform='translate(130.000000, 321.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='41'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              41
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_42'
          transform='translate(130.000000, 339.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='42'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              42
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_43'
          transform='translate(130.000000, 357.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='43'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              43
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_44'
          transform='translate(130.000000, 375.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='44'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              44
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_192'
          transform='translate(166.000000, 423.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='192'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              192
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_193'
          transform='translate(166.000000, 405.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='193'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              193
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_191'
          transform='translate(166.000000, 441.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='191'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              191
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_190'
          transform='translate(166.000000, 459.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='190'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              190
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_189'
          transform='translate(166.000000, 477.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='189'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              189
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_188'
          transform='translate(166.000000, 495.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='188'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              188
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_46'
          transform='translate(130.000000, 411.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='46'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              46
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_45'
          transform='translate(130.000000, 393.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='45'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              45
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_47'
          transform='translate(130.000000, 429.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='47'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              47
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_48'
          transform='translate(130.000000, 447.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='48'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              48
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_49'
          transform='translate(130.000000, 465.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='49'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              49
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_50'
          transform='translate(130.000000, 483.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='50'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              50
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_187'
          transform='translate(166.000000, 513.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='187'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='8.65771484' y='15'>
              187
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_51'
          transform='translate(130.000000, 501.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='51'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              51
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_52'
          transform='translate(130.000000, 519.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='52'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              52
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  )
}
